import { useAuth } from "../context/AuthContext";
import { useSession } from "../context/SessionContext";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function AdminRoute({ children }) {
  const { user, loading, setAppMode } = useAuth();
  const { sessionId, clubId } = useSession();
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (!loading && user?.role === "queue_master") {
      if (!clubId || !user.clubs?.includes(clubId)) {
        setAppMode('player');     // ✅ safe now
        setDenied(true);
      }
    }
  }, [user?.uid, clubId, loading, setAppMode]);

  if (loading) return null;

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  if (user.role !== "queue_master") {
    return <Navigate to="/join" replace />;
  }

  if (denied) {
    return <Navigate to="/join" replace />;
  }

  if (!sessionId) {
    return <Navigate to="/admin/select-session" replace />;
  }

  return children;
}
